import Toggle from '../modules/Toggle'

export default () => {
  jQuery(function($) {
    console.log('Loaded');
    jQuery('.woocommerce').on('change', 'input.qty', function() {
      console.log('Change quantity');
      jQuery("[name='update_cart']").trigger('click')
    })
  })

  jQuery(document.body).on('updated_cart_totals', function() {
    const message = document.querySelector('.woocommerce-message')

    if (message) {
      window.setTimeout(() => {
        message.classList.add('fade')
      }, 3000)

      window.setTimeout(() => {
        message.classList.add('hide')
      }, 4500)
    }

    Toggle()
  })
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/ShoppingCart.js